import "./editorialForms.css";

const categories = [
  { id: "electronics", name: "Eletrônicos" },
  { id: "fashion", name: "Moda" },
  { id: "home", name: "Casa & Decoração" },
  { id: "beauty", name: "Beleza" },
  { id: "sports", name: "Esportes" },
  { id: "toys", name: "Brinquedos" },
  { id: "automotive", name: "Automotivo" },
  { id: "books", name: "Livros" },
  { id: "food", name: "Alimentos" },
  { id: "other", name: "Outros" },
];

export default function EShopForm({ data, onChange }) {
  const handlePriceChange = (field, value) => {
    onChange({
      ...data,
      price: {
        ...data?.price,
        [field]: value,
        currency: data?.price?.currency || "BRL",
      },
    });
  };

  const handleShippingChange = (field, value) => {
    onChange({
      ...data,
      shipping: {
        ...data?.shipping,
        [field]: value,
      },
    });
  };

  return (
    <div className="editorial_form eshop_form">
      <div className="editorial_form_section">
        <label>
          Nome do Produto <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Nome do produto"
          value={data?.productName || ""}
          onChange={(e) => onChange({ ...data, productName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descrição detalhada do produto..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          rows={3}
          maxLength={2000}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Preço <span className="required">*</span>
        </label>
        <div className="editorial_form_row">
          <div className="price_input">
            <span className="currency_prefix">R$</span>
            <input
              type="number"
              placeholder="0,00"
              value={data?.price?.amount || ""}
              onChange={(e) =>
                handlePriceChange("amount", parseFloat(e.target.value) || 0)
              }
              min="0"
              step="0.01"
            />
          </div>
          <div className="price_input original">
            <span className="currency_prefix">De R$</span>
            <input
              type="number"
              placeholder="Preço original (opcional)"
              value={data?.price?.originalPrice || ""}
              onChange={(e) =>
                handlePriceChange(
                  "originalPrice",
                  parseFloat(e.target.value) || 0
                )
              }
              min="0"
              step="0.01"
            />
          </div>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione uma categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Estoque</label>
        <input
          type="number"
          placeholder="Quantidade disponível"
          value={data?.stock || ""}
          onChange={(e) =>
            onChange({ ...data, stock: parseInt(e.target.value) || 0 })
          }
          min="0"
        />
      </div>

      <div className="editorial_form_section">
        <label>Frete</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="freeShipping"
            checked={data?.shipping?.freeShipping || false}
            onChange={(e) =>
              handleShippingChange("freeShipping", e.target.checked)
            }
          />
          <label htmlFor="freeShipping">Frete grátis</label>
        </div>
        {!data?.shipping?.freeShipping && (
          <input
            type="number"
            placeholder="Prazo de entrega (dias)"
            value={data?.shipping?.estimatedDays || ""}
            onChange={(e) =>
              handleShippingChange(
                "estimatedDays",
                parseInt(e.target.value) || 0
              )
            }
            min="1"
            style={{ marginTop: "8px" }}
          />
        )}
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <span>Adicione fotos de boa qualidade do produto</span>
      </div>
    </div>
  );
}
